import { FlowPage, H1, H2, BodyM } from '@monthio/design-system'
import { useTranslation } from 'react-i18next'

export const GeneralErrorPage = () => {
	const { t } = useTranslation()
	return (
		<FlowPage>
			<FlowPage.Content $isCentered>
				<H1>{t('generalErrorPage-errorCode')}</H1>
				<H2>{t('generalErrorPage-title')}</H2>
				<BodyM>{t('generalErrorPage-description')}</BodyM>
			</FlowPage.Content>
			<FlowPage.Footer
				actions={
					<FlowPage.Cta onClick={() => window.location.reload()}>
						{t('generalErrorPage-btn-reloadPage')}
					</FlowPage.Cta>
				}
			/>
		</FlowPage>
	)
}
